import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Popup, Grids, PopupHeader} from 'react-weui';
import axios from 'axios';
import { browserHistory } from 'react-router'

import feedbackImg from '../../images/classroom/icon-feedback.png'
import currentPlayImg from '../../images/classroom/icon-current-play.png'
import playFillImg from '../../images/classroom/icon-play-fill.png'

import '../../styles/classroom/ClassroomControlBar.css';


class ClassroomChannelLecturesPopup extends Component {
    onClickSetting () {
        this.setPopupDisplay(false)
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_OPTIONS'
        })
    }
    onClickToChannel () {
        const { type, channel, recordedLecture } = this.props
        const id = type === 'recorded' ? recordedLecture.channel.id : channel.id
        location.assign(`/channel/${id}`)
    }
    gotoAppPage() {
        this.setPopupDisplay(false)
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'enter_app_from_classroom'
        })
        let goToApp = document.createElement('A');
        goToApp.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike`
        goToApp.id = 'goToApp'
        document.body.appendChild(goToApp);
        document.querySelector('#goToApp').click()
    }
    scrollToCurrentLecture() {
        const { recordedLecture, type, lecture, channelLectures } = this.props
        const lectureId = type === 'recorded' ? recordedLecture.lecture.id : lecture.id
        const index = channelLectures.findIndex(item => item.id === lectureId)
        document.querySelector('.lectures').scrollTo(0, 52 * (index - 2))
    }
    setPopupDisplay (boo) {
        this.props.dispatch({
            type: 'CLASSROOM_SET_MENU_DISPLAY',
            payload: boo
        })
    }
    componentWillReceiveProps (nextProps) {
        if (nextProps.isShowMenuPopup && !this.props.isShowMenuPopup) {
            this.scrollToCurrentLecture()
        }
    }
    onClickLecture (item) {
        if (item.lecture_mode === 'default') {
            location.assign(`/classroom/${item.id}`)
        } else {
            location.assign(`/lecture/${item.id}`)
        }
    }
    onShowDiscussPanel () {
        this.setPopupDisplay(false)
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_DISCUSS_PANEL',
            payload: 'discuss_list'
        })
    }
    render() {
        const {
            channelLectures, channel, role, lecture, isShowMenuPopup, recordedLecture, type
        } = this.props;
        const lectureId = type === 'recorded' ? recordedLecture.lecture.id : lecture.id
        return (
            <div className="classroom-channel-lectures-popup">
                <Popup
                    show={isShowMenuPopup}
                    onRequestClose={e=>this.setPopupDisplay(false)}
                >
                    {
                        channelLectures && channelLectures.length > 0 && (
                            <div onClick={e => this.onClickToChannel()}>
                                <PopupHeader
                                    left={`课程（${channelLectures.length}）`}
                                    right="查看专栏"
                                    leftOnClick={e => e}
                                    rightOnClick={e => e}
                                />
                            </div>
                            
                        )
                    }
                    {/* 课程列表 */}
                    <div className="lectures">
                        {
                            channelLectures && channelLectures.map(item => (
                                <div 
                                    className={`lecture-item wk-border-line-after`} 
                                    key={item.id}
                                    onClick={e => this.onClickLecture(item)}
                                >
                                    <div className="icon">
                                        <img src={lectureId === item.id ? currentPlayImg : playFillImg} alt=""/>
                                    </div>
                                    <div 
                                        className={`name text-ellipsis ${lectureId === item.id ? 'is-green' : ''}`}
                                    >
                                        {item.name}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    {/* 底部选项 */}
                    <div className="fixed-bottom">
                        {
                            type !== 'recorded' && (
                                role.is_lecturer ? (
                                    <div className="bottom-item" onClick={e => {window.MtaH5 && MtaH5.clickStat("live_pay_introduce_page");location.assign(`/lecture/${lecture.id}`)}}>
                                        <div className="img-wrap">
                                            <img src='https://static-cos.lycheer.net/xupload/20180705_icon-lecture.png' alt=""/>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="bottom-item" onClick={e => location.assign(`/lecture/${lecture.id}`)}>
                                        <div className="img-wrap">
                                            <img src='https://static-cos.lycheer.net/xupload/20180705_icon-lecture.png' alt=""/>
                                        </div>
                                    </div>
                                )
                            )
                        }
                        {
                            role.is_lecturer ? (
                                <div className="bottom-item" onClick={e => this.onClickSetting()}>
                                    <div className="img-wrap">
                                        <img src='https://static-cos.lycheer.net/xupload/20180705_icon-setting.png' alt=""/>
                                    </div>
                                </div>
                            ) : (
                                <div className="bottom-item" onClick={e => location.assign(`/complain/lecture/${lectureId}`)}>
                                    <div className="img-wrap">
                                        <img src={this.props.type === 'recorded' ? feedbackImg : 'https://static-cos.lycheer.net/picture/7832811_e94ee7022ca3dcf75d698f16d9c3c3d4.jpg'}  alt=""/>
                                    </div>
                                </div>
                            )
                        }
                        {/* <div className="bottom-item" onClick={e => this.gotoAppPage()}>
                            <div className="img-wrap">
                                <img src='https://static-cos.lycheer.net/xupload/20180705_icon-download.png' alt=""/>
                            </div>
                        </div>   */}
                        <div className="bottom-item" onClick={e => location.assign(`/account/`)}>
                            <div className="img-wrap">
                                <img src='https://static-cos.lycheer.net/picture/7832811_dc2cd36fc895f2d3cd5d10189293cef0.jpg' alt=""/>
                            </div>
                        </div>
                    </div>
                </Popup>
            </div>
        )
    }
}


export default connect((state) => ({
    lecture: state.classroom.lecture,
    channel: state.classroom.channel,
    channelLectures: state.classroom.channelLectures,
    isShowMenuPopup: state.classroom.isShowMenuPopup,
    role: state.classroom.role,
    recordedLecture: state.lecture,
}))(ClassroomChannelLecturesPopup);




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomChannelLecturesPopup.js